import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=255be5ac&scoped=true"
import script from "./addressInfo.vue?vue&type=script&lang=js"
export * from "./addressInfo.vue?vue&type=script&lang=js"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=255be5ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255be5ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255be5ac')) {
      api.createRecord('255be5ac', component.options)
    } else {
      api.reload('255be5ac', component.options)
    }
    module.hot.accept("./addressInfo.vue?vue&type=template&id=255be5ac&scoped=true", function () {
      api.rerender('255be5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/addressInfo.vue"
export default component.exports